import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { format, formatDistanceToNow } from 'date-fns'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTime(timestamp: string): string {
  try {
    const date = new Date(timestamp)
    return format(date, 'HH:mm:ss')
  } catch {
    return timestamp
  }
}

export function formatRelativeTime(timestamp: string): string {
  try {
    const date = new Date(timestamp)
    return formatDistanceToNow(date, { addSuffix: true })
  } catch {
    return timestamp
  }
}
